import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { Text } from "@similarweb/ui-components/foundations";

import { AI_AGENT_STROKE } from "app/pages/sales-intelligence/modules/ai-agent/components";

export const StyledTd = styled.td`
    padding: 12px 20px;
    border-bottom: 1px solid ${colorsPalettes.carbon[100]};
    text-align: left;
    overflow-wrap: break-word;
    ${setFontVariant("body2")}
    color: ${colorsPalettes.carbon[300]};
`;

export const StyledTh = styled(StyledTd)`
    color: ${colorsPalettes.carbon[500]};
`;

export const StyledTable = styled.table`
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 20px;
    table-layout: fixed;

    ${StyledTd}:last-child,
    ${StyledTh}:last-child {
        border-right: none;
    }

    tbody > tr:last-child > td {
        border-bottom: none;
    }
`;

export const StyledLi = styled.li`
    ${setFontVariant("input2", colorsPalettes.carbon[400])};
    line-height: 20px;

    & li {
        margin: 2px 0;
        &:before {
            top: 9px !important;
        }
    }
    & > ul {
        margin-bottom: 2px;
    }
`;

export const StyledUl = styled.ul`
    margin: 0 0 24px 24px;
    & > li {
        position: relative;
        &:before {
            content: "";
            position: absolute;
            top: 7px;
            display: block;
            width: 3px;
            height: 3px;
            border-radius: 50%;
            background-color: ${colorsPalettes.carbon[400]};
            left: -12px;
        }
    }
`;

export const StyledHr = styled.hr`
    border-top: 1px solid ${colorsPalettes.carbon[100]};
    border-bottom: none;
    width: 100%;
    margin: 20px 0;
`;

export const StyledText = styled(Text)`
    &:has(+ ul),
    &:has(+ ol) {
        margin-bottom: 4px;
    }

    &:last-child {
        margin-bottom: 0;
    }
`;

export const StyledAiHr = styled.hr`
    margin: 16px 0;
    height: 1px;
    border: 0;
    background: ${AI_AGENT_STROKE};
`;
